



















































import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { ReferenceFileInformation } from "../../../domain/document";
import { IRectangle } from "../../../domain/system";
import { ReferenceFileViewMixin } from "../../document/mixins";
import { ReferenceFileSelectDialog } from "../../document/editor/dialogs";
import { ModelEditableMixin, PdfStyleDrawableMixin } from "../../system/mixins";
import { IGeometryManageable } from "../../system/utilities";
import PdfViewer from "../../system/viewers/PdfViewer.vue";
import Separator from "../../system/Separator.vue";
import FormatSelector from "../selectors/FormatSelector.vue";
import FormatReferencesListBoxSelector from "../selectors/FormatReferencesListBoxSelector.vue";
import { FormatReference, FormatSet, WriteMethodTypeValue } from "../../../domain/format";
import { IFormatTreeSourceFilterable } from "../selectors/trees/sources";

interface IFormatListViewerGeometry extends IRectangle {
  formatListViewer?: {
    selector: {
      width: number;
    };
  };
}

@Component({
  components: {
    FormatSelector,
    FormatReferencesListBoxSelector,
    pdfViewer: PdfViewer,
    separator: Separator,
    ReferenceFileSelectDialog,
  }
})
export default class FormatListViewer extends Mixins(ModelEditableMixin, PdfStyleDrawableMixin, ReferenceFileViewMixin) implements IGeometryManageable<IFormatListViewerGeometry> {
  static readonly Tabs: {[key: string]: any} = FormatSelector.Tabs;
  static readonly formatTabs: any[] = FormatSelector.formatTabs;
  static readonly formatSetTabs: any[] = FormatSelector.formatSetTabs;
  static readonly allTabs: any[] = FormatSelector.allTabs;

  $refs!: {
    referenceFileSelectDialog: ReferenceFileSelectDialog,
  };

  @Prop({ default: null })
  isReady: boolean;

  @Prop()
  visibleTabs: any[];

  @Prop()
  formatId: number;

  @Prop()
  formatIds: number[];

  @Prop()
  firstSelectedFormatWithoutSort: FormatReference;

  @Prop({ default: null })
  formatName: string;

  @Prop()
  formatTreeSourceFilter: IFormatTreeSourceFilterable;

  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop({ default: false })
  containsExpired: boolean;

  @Prop({ default: false })
  containsDeleted: boolean;

  @Prop({ default: false })
  shouldIgnoreChained: boolean;

  @Prop({ default: null })
  defaultWriteMethodTypes: WriteMethodTypeValue[];

  data(): any {
    return {
      selectorWidth: 1200,
      isEditingFormat: false,
      referenceFiles: null as ReferenceFileInformation[],
      isSpecifiedFormatSelectorInvalid: false,
      specifiedFormatReferences: [] as FormatReference[],
    };
  }
  selectorWidth: number;
  isEditingFormat: boolean;
  referenceFiles: ReferenceFileInformation[];
  isSpecifiedFormatSelectorInvalid: boolean;
  specifiedFormatReferences: FormatReference[];

  created(): void {
    this.$registerGeometryManager(this);
    if (!this.shouldUseFormatSelector) {
      this.initializeSpecifiedFormatReferences();
    }
  }

  destroyed(): void {
    this.$unregisterGeometryManager(this);
  }

  getGeometryNames(isWindowRectangleHandleable: boolean): string[] {
    return [
      "ペイン幅",
    ];
  }

  storeGeomerty(source: IFormatListViewerGeometry, isWindowRectangleHandleable: boolean): void {
    source.formatListViewer = {
      selector: {
        width: this.selectorWidth,
      },
    };
  }

  restoreGeomerty(source: IFormatListViewerGeometry, isWindowRectangleHandleable: boolean): void {
    if (!source.formatListViewer) {
      return;
    }
    this.selectorWidth = source.formatListViewer.selector.width;
  }

  mounted(): void {
    this.selectorWidth = this.$store.getters.configuration.style.format.listViewSelector.selector.width;
  }

  get isFormatSelected(): boolean {
    return (this.editingSource !== null);
  }

  get selectedPreviewSource(): string {
    return (!this.editingSource || !this.editingSource.previewSource)
      ? ""
      : this.editingSource.previewSource.source;
  }

  get hasReferenceFiles(): boolean {
    return this.referenceFiles && this.referenceFiles.length > 0;
  }

  get shouldUseFormatSelector(): boolean {
    return !this.formatIds || this.formatIds.length === 0 || this.isSpecifiedFormatSelectorInvalid;
  }

  private initializeSpecifiedFormatReferences(): void {
    const repository = DomainRegistry.format.getFormatRepository();
    repository.getFormatReferences(this.formatIds)
      .then(f => {
        if (f.length === 0) {
          this.isSpecifiedFormatSelectorInvalid = true;
          this.$error(this.$wording.format.name + "ID不正", "指定された" + this.$wording.format.name + "IDに該当する" + this.$wording.format.name + "が一つも見つかりませんでした。");
          return;
        }
        this.specifiedFormatReferences = f;
      })
      .catch(e => {
        this.isSpecifiedFormatSelectorInvalid = true;
        this.$error(
          this.$wording.format.name + "リスト取得失敗",
          this.$wording.format.name + "リスト取得中にエラーが発生しました。",
          e,
        );
      });
  }

  editingFormat(value: boolean): void {
    // フォーマット選択ダイアログ表示中に編集を行われた場合、DialogMixinで回避出来ずPDFが表示されてしまうため暫定対応
    this.isEditingFormat = value;
  }

  showReferenceFiles(): void {
    if (this.referenceFiles.length === 1) {
      this.openReferenceFileViewer(this.referenceFiles[0]);
    } else {
      this.$refs.referenceFileSelectDialog.show(this.referenceFiles, f => this.openReferenceFileViewer(f));
    }
  }

  async applyLatestFormatReferenceFilesInformation(formatOriginalId: number): Promise<void> {
    const repository = DomainRegistry.format.getFormatRepository();
    this.referenceFiles = await repository.getLatestFormatReferenceFilesInformation(formatOriginalId);
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: any, oldValue: any) {
    if ((newValue && !oldValue) || (newValue && oldValue && newValue.id !== oldValue.id)) {
      this.applyLatestFormatReferenceFilesInformation(newValue.id);
    }
  }

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}

  @Emit("formatSetSelectionChanged")
  onFormatSetSelectionChanged(value: FormatSet): void {}

  @Emit("formatSetDoubleClicked")
  onFormatSetDoubleClicked(): void {}
}
